import React from 'react';
import { Box, Typography } from '@mui/material';
import { KpiStrip } from './KpiStrip';
import { PipelineFlow } from './PipelineFlow';
import { QuoteTable } from './QuoteTable';
import { SectionCard } from './SectionCard';
import { EstadoBolsa } from '../state/bolsaMachine';
import { BolsaCentro, MetricasCentro } from '../types';

interface CotizacionesTabProps {
  loading: boolean;
  metricas: MetricasCentro | null;
  bolsasAbiertas: BolsaCentro[];
  cotizaciones: BolsaCentro[];
  filtradas: BolsaCentro[];
  filtroEstado: EstadoBolsa | 'TODAS';
  busqueda: string;
  onFiltrar: (estado: EstadoBolsa | 'TODAS') => void;
  onBuscar: (valor: string) => void;
  onAbrirDrawer: (id: string) => void;
  onVerBolsasAbiertas: () => void;
  onVerDetalle: (id: string) => void;
}

export const CotizacionesTab: React.FC<CotizacionesTabProps> = (props) => {
  if (props.loading) {
    return (
      <Typography sx={{ fontFamily: 'Poppins, sans-serif', color: '#A79AA7', textAlign: 'center', padding: '60px 0' }}>
        Cargando…
      </Typography>
    );
  }

  return (
    <Box data-testid="tab-panel-cotizaciones">
      <KpiStrip metricas={props.metricas} cotizaciones={props.cotizaciones} />
      <SectionCard title="Flujo del pipeline">
        <PipelineFlow
          bolsasAbiertas={props.bolsasAbiertas}
          cotizaciones={props.cotizaciones}
          onFiltrar={props.onFiltrar}
          onVerBolsasAbiertas={props.onVerBolsasAbiertas}
        />
      </SectionCard>
      <SectionCard title="Cotizaciones">
        <QuoteTable
          cotizaciones={props.cotizaciones}
          filtradas={props.filtradas}
          filtroEstado={props.filtroEstado}
          busqueda={props.busqueda}
          onFiltrar={props.onFiltrar}
          onBuscar={props.onBuscar}
          onAbrirDrawer={props.onAbrirDrawer}
          onVerDetalle={props.onVerDetalle}
        />
      </SectionCard>
    </Box>
  );
};
